import { useState } from 'react';

export const useHover = () => {
  const [hover, setHover] = useState(false);

  return {
    hoverProps: {
      onMouseEnter: () => setHover(true),
      onMouseLeave: () => setHover(false),
      cursor: 'pointer',
    },
    hover,
  };
};
